import React ,{useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import defaultStyles from './uploadImPerLotFile.module.scss';
import {uploadFileConnected, uploadMonthlyFile, refreshMonthlyUploadData, validateMonthlyFile, uploadMonthlyFileSuccessConfirm, setGridSorts} from '../actions'
import FilterHeader from '../../webcommon/header/filterheader/FilterHeader';
import moment from 'moment';
import Modal from '../../webcommon/common/modal/Modal';
import Dropzone from '../../webcommon/common/dropzone/Dropzone';
import ActionButton from '../../webcommon/common/actionbutton/ActionButton';
import GridHeader from '../../common/gridheader/GridHeader';
import Grid from '../../webcommon/grid/Grid';
import {incomingFileDataConst, columnsGrid1, columnsFilePreview} from '../constants'
import {getDefaultSort} from '../selectors'
import { findGridSort } from "../../common/helpermethods/HelperMethods"

const ImPerLotUploadFile = (props)=> {

    const {
        uploadFileConnected,
        location,
        uploadFile,
        dateProp,
        fileNameProp,
        validateFile
    } = props;    
    
    const [modalOpen, toggleModal] = useState(false);
    const [fileUploadedLocally, setfileUploadedLocally] = useState(false)
    const [uploadFileClicked, setUploadFileClicked] = useState(false)

    useEffect(() => {
        uploadFileConnected(location.search);
    },[uploadFileConnected, location]);

    const SendFileForValidationAndCloseModal = (file)  => {
        let fileData = new FormData();
        fileData.append(
            "commodityFile",
            file,
            file.name
        )        
        validateFile(fileData);
        toggleModal(!modalOpen);
        setfileUploadedLocally(true);
        setUploadFileClicked(false)
    }
    const UploadDataAndResetComponent = () => {
        if (uploadFileClicked) return
        let dataToSubmit = {
            rows: props.rowsPreview,
            date: date
        }
        uploadFile(dataToSubmit)
        setUploadFileClicked(true)
    }
    let incomingFileData = incomingFileDataConst        
    let fileUploaded = fileNameProp === ('ImPerLot_' + dateProp + '.csv')
    let formData = null;
       
    if (props.isUploaded && props.waiting){         
        //setUploadFileClicked(false)
        props.uploadFileSuccessConfirm('File Successfully uploaded')    
        
        console.log('hello')
    }
    
    let date = null;   
    if (dateProp){
        date = moment(dateProp).format('YYYY-MM-DD');
        incomingFileData[0].runDate = date;
    }
    let data = {runDate: null, file: null};
    

    if (date && formData){
        data.runDate = date;
        data.file = formData;
        }

    if (fileUploaded){
        incomingFileData[0].sent = 'Yes';
    }

       

    return (
        <div className={props.styles.wrapper}>
            <div className={props.styles.filter}>
                <FilterHeader fixed title="Select File and Run Date" id="CommodityReportUpload" />                                                
                {fileUploadedLocally && date && <div>
                        <div className={props.styles.gridHeader}>
                            <GridHeader
                                title="File Preview"                                                       
                            >
                                </GridHeader>                    
                        </div>
                        <div className={props.styles.grid}>
                            <Grid
                                columns={columnsFilePreview}
                                rows={props.rowsPreview}
                                loading={ props.loading }
                    />
                        </div>
                    </div>}
                <div className={props.styles.buttonWrapper}>
                      
                    <div className={props.styles.button2}>
                        <ActionButton onClick={() => toggleModal(!modalOpen)}>
                            &nbsp;&nbsp;Select {fileUploadedLocally && `Other `}File To Upload&nbsp;&nbsp;
                        </ActionButton>
                    </div>
                    {props.isValidated && date && <div className={props.styles.button}>
                        <ActionButton
                                accent
                                onClick={() => UploadDataAndResetComponent()}
                            >&nbsp;&nbsp;Upload Selected File&nbsp;&nbsp;
                        </ActionButton>
                    </div>}  
                </div>                                 
                <div className={props.styles.modal}>                    
                        <Modal
                            isOpen={modalOpen}
                            closeModal= {() => toggleModal(!modalOpen)}>                          
                            <div className={props.styles.dropZoneWrapper}>
                                <Dropzone onDrop={ (file) => {SendFileForValidationAndCloseModal(file)} } />
                            </div>
                        </Modal>  
                </div>                
            </div>            
            <div className={props.styles.gridWrapper}>
                <div className={props.styles.gridHeader}>
                <GridHeader
                    title="Files Uploaded"      
                    refreshControlsActive
                    refreshData={ props.refreshUploadData }    
                    lastUpdated ={props.lastUpdated}              
                    />                    
                </div>
                <div className={props.styles.grid}>
                <Grid
                    sortable
                    columns={columnsGrid1}
                    defaultColumnSpacing={ 2 }
                    rows={props.rows}
                    loading={ props.loading }
                    defaultSorted={ findGridSort(props.defaultSort,
                        'timestampSort') }
                    onSortedChange={ (newSorted) => {
                            props.setGridSorts('timestampSort', newSorted);
                        } }
                    />
                </div>
            </div>                            
        </div>       
        ); 
}
ImPerLotUploadFile.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    uploadFileConnected: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string),
    dateProp: PropTypes.string
};

ImPerLotUploadFile.defaultProps = {
     styles: defaultStyles,
     dateProp: '',
};

const mapDispatchToProps = {
    uploadFileConnected,
    uploadFile: uploadMonthlyFile,
    refreshUploadData: refreshMonthlyUploadData,
    validateFile: validateMonthlyFile,
    uploadFileSuccessConfirm: uploadMonthlyFileSuccessConfirm,
    setGridSorts,
};

const mapStateToProps = state => ( 
    {   
        dateProp: state.commodityReport.runDate,
        fileNameProp: state.commodityReport.fileName,
        fileCreatedAtProp: state.commodityReport.fileUploadedAt,
        rows: state.commodityReport.fileUploadRows,
        rowsPreview: state.commodityReport.rowsPreview,
        isValidated: state.commodityReport.isValidated,
        isUploaded: state.commodityReport.isUploaded,
        waiting: state.commodityReport.waitingForNotification,
        lastUpdated: state.commodityReport.lastUpdatedMonthly,
        defaultSort: getDefaultSort(state),
    }
)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ImPerLotUploadFile));
